export const cacheVariablesIsTransform = (cacheVariables) => {
    return typeof cacheVariables === 'function';
};
